import { c as _c } from "react/compiler-runtime";
import { getTimeAgoShort } from "@/helpers/Helpers";
interface NotificationTimestampProps {
  readonly createdAt: number;
}
export default function NotificationTimestamp(t0) {
  const $ = _c(5);
  const {
    createdAt
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== createdAt) {
    t2 = getTimeAgoShort(createdAt);
    $[1] = createdAt;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t1}{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}